import { useCleanText } from "@/shared/client";
import { MEDIA } from "@/styles/common";
import { removeHtmlTags } from "@/utils";
import { Flex, Text } from "@chakra-ui/react";
import { useLocation } from "react-router-dom";
import { CustomBox, CustomSubBox, CustomSubText } from "./catchPraise.style";
import { type CatchPraiseProps } from "./catchPraise.type";

export const CatchPraise = ({ catchPraise, annotation, isDetail }: CatchPraiseProps) => {
    const { main, sub } = catchPraise;
    const { isMobile } = MEDIA();
    const { pathname } = useLocation();

    const isMainEnglish = /^[a-zA-Z\s,.'";:!?&()-]+$/.test(main.firstLine);
    const isSubEnglish = /^[a-zA-Z\s,.'";:!?&()-]+$/.test(sub.firstLine);

    const { cleanText } = useCleanText(sub.secondLine);

    return (
        <Flex flexDir="column" rowGap="16px" textAlign="left">
            <CustomBox annotation={annotation} pl={isMobile ? "20px" : "36px"}>
                {annotation && <Text className="catch_praise_annotation">{annotation}</Text>}
                <Text className={isMainEnglish ? "main_en" : "main_kr"}>
                    {removeHtmlTags(main.firstLine, "<br>").cleanText}
                </Text>
                {main.secondLine && (
                    <Text className={isMainEnglish ? "main_en" : "main_kr"}>
                        {removeHtmlTags(main.secondLine, "<br>").cleanText}
                    </Text>
                )}
            </CustomBox>
            <CustomSubBox pl={isMobile ? "20px" : "36px"} flexDir="column" rowGap="16px">
                <Text className={isSubEnglish ? "sub_en" : "sub_kr"}>
                    {removeHtmlTags(sub.firstLine, "<br>").cleanText}
                </Text>
                {sub.secondLine && (
                    <CustomSubText isDetail={isMobile ? !isDetail : isDetail} pathName={pathname}>
                        <Flex flexDir="column" gap="4px" className={isSubEnglish ? "sub_en" : "sub_kr"}>
                            {Array.isArray(cleanText)
                                ? cleanText.map((text) => (
                                      <p key={text} className={isSubEnglish ? "sub_en" : "sub_kr"}>
                                          {text}
                                      </p>
                                  ))
                                : cleanText}
                        </Flex>
                    </CustomSubText>
                )}
            </CustomSubBox>
        </Flex>
    );
};
